// extracted by mini-css-extract-plugin
export default {"container":"DefaultLayout_container__NgAo7","content":"DefaultLayout_content__e9Pwb"};